import NavBar from "../NavBar/NavBar";

const Login = (props) => {
  return (
    <>
      <NavBar curPage="/login" />
      <div className="container min-vh-100">
        <div className="row mt-5">
          <div className="col-12 align-middle text-center">
            <h1 className="align-middle text-center">Coming Soon!</h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
